import { ErrorHandler, Injectable } from '@angular/core';
import { reportRuntimeErrorToSentry } from './sentry-runtime-error.reporter';
import { recoverFromChunkLoadError } from './chunk-load-recovery';

/**
 * ErrorHandler global do Angular: captura exceções de runtime não tratadas
 * (fora do ciclo HTTP) e as envia ao Sentry com throttling. Os erros de
 * requisição são reportados pelo SentryErrorInterceptor, com o contexto completo
 * da requisição, então aqui são ignorados (ver reportRuntimeErrorToSentry).
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // Angular embrulha alguns erros; usa o original quando disponível.
    const originalError = (error as { ngOriginalError?: unknown })?.ngOriginalError ?? error;

    // Falha ao carregar um chunk lazy (rota ou @defer) após um novo deploy:
    // recupera com um reload único (guarded) e não reporta ao Sentry, pois é
    // ruído esperado pós-deploy.
    if (recoverFromChunkLoadError(originalError)) return;

    reportRuntimeErrorToSentry(originalError);

    // Mantém o comportamento padrão de logar no console.
    console.error(originalError);
  }
}
